import baseApi from "./baseApi"

export default  {
    async getBreakTypes() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/attendance/breakTypes");
        return result.data;
    },

    async getAttendanceByID(id) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/attendance/" + id);
        return result.data;
    },

    async updateAttendance(model) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/attendance", model);
        return result.data;
    }
}